import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

const ServerStatusBadge = () => {
  const [state, setState] = useState({ status: null, players: 0, max: 100 });

  useEffect(() => {
    let alive = true;
    const poll = async () => {
      try {
        const { data } = await api.get("/server/status");
        if (alive) setState({ status: data.status, players: data.players, max: data.max_players });
      } catch {
        if (alive) setState((s) => ({ ...s, status: "offline" }));
      }
    };
    poll();
    const t = setInterval(poll, 30000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  const status = state.status;
  const reconnecting = status === "reconnecting";
  const offline = status === "offline";
  const color = offline ? "#E4443A" : reconnecting ? "#FFB703" : status === "online" ? "#2ECC71" : "#64748B";
  return (
    <Link
      to="/live"
      data-testid="server-status-badge"
      title={offline ? "Server offline" : reconnecting ? "Reconnecting to server…" : "Server online — view live"}
      className="hidden md:inline-flex items-center gap-2 h-9 px-3 border border-[#2A2E3D] hover:border-[#D4A94A]/60 tactical-frame-sm font-mono text-[11px] uppercase tracking-wider transition-colors"
    >
      <span className="relative flex h-2 w-2">
        {!offline && <span className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-60" style={{ background: color }} />}
        <span className="relative inline-flex rounded-full h-2 w-2" style={{ background: color }} />
      </span>
      {offline ? (
        <span style={{ color }}>Offline</span>
      ) : reconnecting ? (
        <span style={{ color }}>Reconnecting…</span>
      ) : (
        <span className="text-[#94A3B8]">Server <span className="text-[#F1F5F9]">{state.players}</span>/{state.max}</span>
      )}
    </Link>
  );
};

export default ServerStatusBadge;
